<div
  [formGroup]="formGroup"
  *ngIf="mode === 'single'"
  id="mode-single"
>
  <tui-input-phone
    [formControlName]="formControlName"
    [countryCode]="''"
    [phoneMaskAfterCountryCode]="mask"
    [nativeId]="id"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [pseudoFocus]="focus ?? null"
    [readOnly]="properties?.readOnly ?? false"
    (focusedChange)="handleFocusedChange($event)"
  >
    {{ label }}
    <span
      class="tui-required"
      *ngIf="validators.required"
    ></span>
    <input
      tuiTextfield
      inputmode="numeric"
      [attr.placeholder]="placeholder ?? ''"
      [attr.required]="validators.required"
    />
  </tui-input-phone>
</div>
<div
  [formGroup]="formGroup"
  *ngIf="mode === 'multiple'"
  id="mode-multiple"
>
  <div
    id="mode-multiple-label"
    *ngIf="label !== ''"
  >
    <span class="t-label">
      <b>
        <p class="tui-space_bottom-1 tui-space_left-1 ng-star-inserted">
          {{ label }}
          <span
            class="tui-required"
            *ngIf="validators.required"
          ></span>
        </p>
      </b>
    </span>
  </div>
  <div id="mode-multiple-inputs">
    <kwikui-input-otp-multiple
      [formCtrl]="formControl"
      [config]="otpMultipleConfig"
      [invalid]="invalid === undefined ? null : invalid"
      [disabled]="disabled"
      [readOnly]="properties?.readOnly ?? false"
      (onInputChange)="handleInputValueChangeMultiple($event)"
    ></kwikui-input-otp-multiple>
  </div>
</div>
